import { observable, action, flow } from 'mobx';
import { get } from 'lodash';
import Serv from './QualificationPageServ';
import { Toast } from 'antd-mobile';

const defaultListData = {
  data: null,
  isLoading: false,
  hasPullToRefresh: true,
  pageNum: 1,
  pages: 1
};

class QualificationPageMod {
  // 资格购活动id
  @observable id = '';

  @observable hasRequest = false; // 是否已请求

  @observable scrollTop = 0; // 滚动高度

  @observable activityList = [];

  // 产品列表数据
  @observable listData = defaultListData;
  // 资格购前端隐藏，可以通过跳转链接参与活动
  @observable showFlag = false;
  // 客服复制链接标识
  @observable ment = '';

  @action
  changeModState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取资格购列表
   * show 1 显示隐藏活动
   */
  getQualificationList = flow(function* () {
    Toast.loading('加载中...');
    try {
      let { data } = yield Serv.getQualificationList({
        isPurchasingAgent: 0,
        show: this.showFlag ? 1 : 0
      });
      if (Array.isArray(data)) {
        this.activityList = data;
      }
      Toast.hide();
    } catch (e) {
      Toast.hide();
    }
  });

  @action
  resetData() {
    this.listData = defaultListData;
    this.hasRequest = false;
    this.scrollTop = 0;
  }
}

const qualificationPageMod = new QualificationPageMod();
export default qualificationPageMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/QualificationPage/QualificationPageMod.js